import { StaticQuery, graphql } from 'gatsby'
import React from 'react'
import Img from 'gatsby-image'
import { injectIntl } from 'react-intl'
import { findLocalized } from '../utils'

const Footer = ({intl: {locale}}) => (
  <StaticQuery
    query={graphql`
      query {
        bubble: file(relativePath: {eq: "bubble.png"}){
          childImageSharp{
            fluid{
              ...GatsbyImageSharpFluid
            }
          }
        }
        focus: allFocusYaml{
          edges{
            node{
              title
              text
              list
              lang
            }
          }
        }       
      }
    `}
    render={data => {
      const { title, text, list } = findLocalized(data.focus, locale);
      return (
        <section id="focus" className="section focus text-center" aria-labelledby="region-focus">
          <div className="container">
            <div className="row" data-aos="fade-up">
              <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
              <Img fluid={data.bubble.childImageSharp.fluid} alt="bubble icon" className="section__img" />
                <h1 id="region-focus" className="section__title">{title}</h1>
                <p dangerouslySetInnerHTML={{__html: text}}></p>
                <div className="row">
                  <div className="col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3">
                    <ul className="focus__list">
                      {list.map((item, i) => <li className="focus__item" key={i}>{item}</li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    }}
  />
)

export default injectIntl(Footer);
